var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"settings"},[(_vm.ready && _vm.settingsConfig.length)?_c('admin-settings',_vm._b({attrs:{"settingsConfig":_vm.settingsConfig}},'admin-settings',_vm.settings,false)):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }